export const ONE_DAY_MS = 1000 * 60 * 60 * 24;

export const ONE_MINUTE_MS = 1000 * 60;

export const ONE_DAY_MINUTES = 24 * 60;
